
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
if ($(window).width() < 600) // jQuery lightSlider Cover
$(document).ready(function() {
    $("#light-slider").lightSlider({
        item: 2,
        autoWidth: false,
        slideMove: 1,
        slideMargin: 0,
        addClass: "",
        mode: "slide",
        useCSS: true,
        cssEasing: "ease",
        easing: "linear",
        speed: 400,
        auto: true,
        pauseOnHover: false,
        loop: true,
        slideEndAnimation: true,
        pause: 8000,
        keyPress: false,
        controls: true,
        prevHtml: "",
        nextHtml: "",
        rtl: false,
        adaptiveHeight: false,
        vertical: false,
        verticalHeight: 500,
        vThumbWidth: 100,
        thumbItem: 10,
        pager: false,
        gallery: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: "middle",
        enableTouch: true,
        enableDrag: true,
        freeMove: true,
        swipeThreshold: 40,
        responsive: [],
        onBeforeStart: function(el) {},
        onSliderLoad: function(el) {},
        onBeforeSlide: function(el) {},
        onAfterSlide: function(el) {},
        onBeforeNextSlide: function(el) {},
        onBeforePrevSlide: function(el) {}
    });
    AOS.init({
        disable: window.innerWidth < 991
    }); // initializing aos scroll
});
else // jQuery lightSlider Cover
$(document).ready(function() {
    $("#light-slider").lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 1,
        slideMargin: 0,
        addClass: "",
        mode: "slide",
        useCSS: true,
        cssEasing: "ease",
        easing: "linear",
        speed: 400,
        auto: true,
        pauseOnHover: false,
        loop: true,
        slideEndAnimation: true,
        pause: 8000,
        keyPress: false,
        controls: true,
        prevHtml: "",
        nextHtml: "",
        rtl: false,
        adaptiveHeight: false,
        vertical: false,
        verticalHeight: 500,
        vThumbWidth: 100,
        thumbItem: 10,
        pager: false,
        gallery: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: "middle",
        enableTouch: true,
        enableDrag: true,
        freeMove: true,
        swipeThreshold: 40,
        responsive: [],
        onBeforeStart: function(el) {},
        onSliderLoad: function(el) {},
        onBeforeSlide: function(el) {},
        onAfterSlide: function(el) {},
        onBeforeNextSlide: function(el) {},
        onBeforePrevSlide: function(el) {}
    });
    AOS.init({
        disable: window.innerWidth < 991
    }); // initializing aos scroll
});
// jQuery lightSlider Brands
$(document).ready(function() {
    $("#light-slider-brands").lightSlider({
        item: 5,
        autoWidth: false,
        slideMove: 1,
        slideMargin: 0,
        addClass: "",
        mode: "slide",
        useCSS: true,
        cssEasing: "ease",
        easing: "linear",
        speed: 400,
        auto: true,
        pauseOnHover: false,
        loop: true,
        slideEndAnimation: true,
        pause: 8000,
        keyPress: false,
        controls: true,
        prevHtml: "",
        nextHtml: "",
        rtl: false,
        adaptiveHeight: false,
        vertical: false,
        verticalHeight: 500,
        vThumbWidth: 100,
        thumbItem: 10,
        pager: true,
        gallery: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: "middle",
        enableTouch: true,
        enableDrag: true,
        freeMove: true,
        swipeThreshold: 40,
        responsive: [],
        onBeforeStart: function(el) {},
        onSliderLoad: function(el) {},
        onBeforeSlide: function(el) {},
        onAfterSlide: function(el) {},
        onBeforeNextSlide: function(el) {},
        onBeforePrevSlide: function(el) {}
    });
}); // allows us to choose what this file will export if another file will try to import it.
 // export default lightSLider


// Remove .active class from navbar when in burger menu
jQuery(document).ready(function($) {
    var alterClass = function() {
        var ww = document.body.clientWidth;
        if (ww < 992) $(".activeNavbarPagination").removeClass("active").addClass("text-dark shadow-sm border border-2"); //Changing Navigation styles in mobile view
        else if (ww >= 993) $(".activeNavbarPagination").addClass("active").removeClass("text-dark shadow-sm border border-2"); //Making it normal again for big view
    };
    $(window).resize(function() {
        alterClass();
    });
    //Fire it when the page first loads:
    alterClass();
}); //   export default burgerMenu


// Changes Favicon based on system settings
let $42cdda09685a2f14$var$matcher = window.matchMedia("(prefers-color-scheme: dark)");
$42cdda09685a2f14$var$matcher.addEventListener("change", $42cdda09685a2f14$var$onUpdate);
$42cdda09685a2f14$var$onUpdate();
lightSchemeIcon = document.querySelector("#light-scheme-icon");
darkSchemeIcon = document.querySelector("#dark-scheme-icon");
function $42cdda09685a2f14$var$onUpdate() {
    if ($42cdda09685a2f14$var$matcher.matches) {
        lightSchemeIcon.remove();
        document.head.append(darkSchemeIcon);
    } else {
        document.head.append(lightSchemeIcon);
        darkSchemeIcon.remove();
    }
} // export default favicon


var $069407aaccc90e9d$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ "use strict";
var $069407aaccc90e9d$var$OFI = "bfred-it:object-fit-images";
var $069407aaccc90e9d$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $069407aaccc90e9d$var$testImg = typeof Image === "undefined" ? {
    style: {
        "object-position": 1
    }
} : new Image();
var $069407aaccc90e9d$var$supportsObjectFit = "object-fit" in $069407aaccc90e9d$var$testImg.style;
var $069407aaccc90e9d$var$supportsObjectPosition = "object-position" in $069407aaccc90e9d$var$testImg.style;
var $069407aaccc90e9d$var$supportsOFI = "background-size" in $069407aaccc90e9d$var$testImg.style;
var $069407aaccc90e9d$var$supportsCurrentSrc = typeof $069407aaccc90e9d$var$testImg.currentSrc === "string";
var $069407aaccc90e9d$var$nativeGetAttribute = $069407aaccc90e9d$var$testImg.getAttribute;
var $069407aaccc90e9d$var$nativeSetAttribute = $069407aaccc90e9d$var$testImg.setAttribute;
var $069407aaccc90e9d$var$autoModeEnabled = false;
function $069407aaccc90e9d$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $069407aaccc90e9d$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$069407aaccc90e9d$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $069407aaccc90e9d$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $069407aaccc90e9d$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $069407aaccc90e9d$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $069407aaccc90e9d$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($069407aaccc90e9d$var$nativeGetAttribute.call(img, "src") !== placeholder) $069407aaccc90e9d$var$nativeSetAttribute.call(img, "src", placeholder);
}
function $069407aaccc90e9d$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($069407aaccc90e9d$var$onImageReady, 100, img, callback);
}
function $069407aaccc90e9d$var$fixOne(el) {
    var style = $069407aaccc90e9d$var$getStyle(el);
    var ofi = el[$069407aaccc90e9d$var$OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style["object-fit"] === "fill") return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $069407aaccc90e9d$var$supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $069407aaccc90e9d$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $069407aaccc90e9d$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $069407aaccc90e9d$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $069407aaccc90e9d$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $069407aaccc90e9d$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = "";
        try {
            $069407aaccc90e9d$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn("https://bit.ly/ofi-old-browser");
        }
    }
    $069407aaccc90e9d$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";
    if (/scale-down/.test(style["object-fit"])) $069407aaccc90e9d$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = "contain";
        else el.style.backgroundSize = "auto";
    });
    else el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    $069407aaccc90e9d$var$onImageReady(ofi.img, function(img) {
        $069407aaccc90e9d$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $069407aaccc90e9d$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$069407aaccc90e9d$var$OFI].img[prop ? prop : "src"];
        },
        set: function set(value, prop) {
            el[$069407aaccc90e9d$var$OFI].img[prop ? prop : "src"] = value;
            $069407aaccc90e9d$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $069407aaccc90e9d$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
        get: function() {
            return descriptors.get("currentSrc");
        }
    });
    Object.defineProperty(el, "srcset", {
        get: function() {
            return descriptors.get("srcset");
        },
        set: function(ss) {
            return descriptors.set(ss, "srcset");
        }
    });
}
function $069407aaccc90e9d$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$069407aaccc90e9d$var$OFI] && el[$069407aaccc90e9d$var$OFI].img && (name === "src" || name === "srcset") ? el[$069407aaccc90e9d$var$OFI].img : el;
    }
    if (!$069407aaccc90e9d$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $069407aaccc90e9d$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $069407aaccc90e9d$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $069407aaccc90e9d$var$fix(imgs, opts) {
    var startAutoMode = !$069407aaccc90e9d$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";
    if ($069407aaccc90e9d$var$supportsObjectPosition && !opts.skipTest || !$069407aaccc90e9d$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === "img") imgs = document.getElementsByTagName("img");
    else if (typeof imgs === "string") imgs = document.querySelectorAll(imgs);
    else if (!("length" in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$069407aaccc90e9d$var$OFI] = imgs[i][$069407aaccc90e9d$var$OFI] || {
            skipTest: opts.skipTest
        };
        $069407aaccc90e9d$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener("load", function(e) {
            if (e.target.tagName === "IMG") $069407aaccc90e9d$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $069407aaccc90e9d$var$autoModeEnabled = true;
        imgs = "img"; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener("resize", $069407aaccc90e9d$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$069407aaccc90e9d$var$fix.supportsObjectFit = $069407aaccc90e9d$var$supportsObjectFit;
$069407aaccc90e9d$var$fix.supportsObjectPosition = $069407aaccc90e9d$var$supportsObjectPosition;
$069407aaccc90e9d$var$hijackAttributes();
$069407aaccc90e9d$exports = $069407aaccc90e9d$var$fix;


let $f7fca9471e720bd1$var$windowWidth = window.innerWidth; // reload page on resize
window.addEventListener("resize", function() {
    "use strict";
    if (window.innerWidth !== $f7fca9471e720bd1$var$windowWidth) {
        $f7fca9471e720bd1$var$windowWidth = window.innerWidth;
        window.location.reload();
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($069407aaccc90e9d$exports)))(); // init safari image fix


//# sourceMappingURL=index.ca9fc5ee.js.map
